module.exports = __webpack_public_path__ + "img/configuracoes.3324b5d1.svg";